import { render, staticRenderFns } from "./number.vue?vue&type=template&id=4111b98c&scoped=true&"
import script from "./number.vue?vue&type=script&lang=ts&"
export * from "./number.vue?vue&type=script&lang=ts&"
import style0 from "./number.vue?vue&type=style&index=0&id=4111b98c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4111b98c",
  null
  
)

export default component.exports